import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Select,
  FormControl,
  MenuItem,
  Tooltip,
  FormLabel
} from "@material-ui/core";
import "./addUpdateContact.less";
import { API_URL } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { apiPost, apiPut, apiRequest } from "../../../utils/api_service";
import {
  PaperComponent,
  IsTenant,
  IsTenantAdmin,
  GetUserConfiguration,
  GetEnableProperty,
  GetPropertyVisibility
} from "../../../utils/helper";
import LabelWithSwitch from "../../common/switchWithLabel/switchWithLabel";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { remove } from "lodash/array";
import { validateInput } from "../../../utils/validations";
import InputMask from "react-input-mask";
import KeyBoardDatePickers from "../../common/KeyboardDatePicker/DatePicker";
import TextFieldWithToolTip from "../../common/TextFieldWithToolTip/TextFieldWithToolTip";
import { InfoOutlined } from "@material-ui/icons";
import moment from "moment";
import { SECTIONS, standardDateFormat } from "../../../constants/appConstants";

const contactValidation = [
  {
    valueKey: "userName",
    type: "text",
    isRequired: true,
    fieldsName: "Contact Name"
  },
  { valueKey: "email", type: "email", isRequired: true, fieldsName: "Email" },
  {
    valueKey: "permissionRequestTypeIds",
    type: "array",
    isRequired: true,
    fieldsName: "Request Permission"
  },
  {
    valueKey: "effectiveDate",
    type: "date",
    isRequired: true,
    fieldsName: "Effective from"
  },
  {
    valueKey: "expireDate",
    type: "date",
    isRequired: false,
    fieldsName: "Effective to"
  },
  {
    valueKey: "propertyId",
    type: "text",
    isRequired: true,
    fieldsName: "Data Center"
  },
  {
    valueKey: "officePhone",
    type: "phone",
    isRequired: false,
    fieldsName: "Work Phone"
  },
  {
    valueKey: "cellPhone",
    type: "phone",
    isRequired: false,
    fieldsName: "Cell Phone"
  }
];

class AddUpdateTenantContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTenantId: props.tenantId,
      tenantsFromTenantView: props.tenantsFromTenantView || [],
      tenantContactId: props.tenantContactId || null,
      contactName: "",
      email: "",
      officePhone: "",
      cellPhone: "",
      permissionRequestTypeIds: [],
      effectiveFromDate: new Date(),
      isAdminContactType: false,
      selectedPropertyId: props.propertyId ? props.propertyId : null,
      dataCenterList: [],
      contactSuggestions: props.tenantContactsList
        ? props.tenantContactsList.map(x => {
            return { title: x.UserName, id: x.PropertyId };
          })
        : [],
      contactFocus: false,
      selectAllRequestPermission: false,
      tenantEffectiveToDate: props.tenantEffectiveToDate
        ? props.tenantEffectiveToDate
        : null,
      effectiveToDate: props.tenantEffectiveToDate
      ? props.tenantEffectiveToDate
      : null,
      sendEmail: false,
      getToolTip: props.toolTipData || [],
      isReceiveCommunication: true,
      invitationSentDate: null,
      createdOn: null,
      modifiedOn: null
    };
  }

  componentDidMount() {    
    this.getDataCenterList();
  }

  /**
   * get data center master list
   */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: dataCenterList }) => {
        const {selectedPropertyId, tenantContactId} = this.state;
        if (
          tenantContactId == 0 &&
          selectedPropertyId <= 0
        ) {
          this.setState({
            dataCenterList:( tenantContactId == null ||  tenantContactId == undefined || tenantContactId == 0) ? GetEnableProperty((dataCenterList || []), SECTIONS.ADD_UPDATE_TENANT ): dataCenterList,
            selectedPropertyId: dataCenterList.slice(0, 1).propertyID
          }, ()=> {
            tenantContactId &&
                this.getTenantContactById(tenantContactId);      
          });
        } else {
          
          this.setState({
            dataCenterList: ( tenantContactId == null ||  tenantContactId == undefined || tenantContactId == 0) ? GetEnableProperty((dataCenterList || []), SECTIONS.ADD_UPDATE_TENANT ): dataCenterList,
            selectedPropertyId:
              dataCenterList.length == 1
                ? dataCenterList[0].propertyID
                : selectedPropertyId
          }, ()=> {
            tenantContactId &&
                this.getTenantContactById(tenantContactId);      
          });
        }
      }
    );
  };

  /**
   * get tenant contact data by id
   * @param {*} tenantContactId 
   */
  getTenantContactById = tenantContactId => {
    const params = {
      tenantContactId: tenantContactId,
      dateOffset: moment().utcOffset(),
    };
    apiRequest({
      url: API_URL.tenantContact.GetTenantContactById,
      params
    }).then(({ data: tenantContact }) => {
      let { dataCenterList } = this.state;
      const disabledProperty = GetPropertyVisibility(SECTIONS.ADD_UPDATE_TENANT);
      const notSelectedDisabledProperty = disabledProperty.filter(x=> x !== tenantContact.PropertyId);
      dataCenterList = dataCenterList.filter(dc => (notSelectedDisabledProperty || []).find(x=> x === dc.propertyID) === undefined);
      if (tenantContact) {
        this.setState({
          dataCenterList,
          tenantContactId: tenantContactId,
          contactName: tenantContact.UserName,
          email: tenantContact.Email,
          officePhone: tenantContact.OfficePhone,
          cellPhone: tenantContact.CellPhone,
          permissionRequestTypeIds: tenantContact.RequestTypeId
            ? tenantContact.RequestTypeId.split(",").map(i => Number(i))
            : [],
          effectiveFromDate: tenantContact.EffectiveDate
            ? tenantContact.EffectiveDate
            : new Date(),
          effectiveToDate: tenantContact.ExpireDate
            ? tenantContact.ExpireDate
            : null,
          isAdminContactType:
            tenantContact.ContactType == "Admin" ? true : false,
          selectedPropertyId: tenantContact.PropertyId,
          tenantEffectiveToDate: tenantContact.TenantEffectiveToDate,
          isReceiveCommunication: tenantContact.IsReceiveCommunication === "Yes",
          invitationSentDate: tenantContact.InvitationSentDate,
          createdOn: tenantContact.CreatedOn,
          modifiedOn: tenantContact.ModifiedOn
        });
      } else {
        ShowToast(
          "Something went wrong, please try again.",
          toastType.ERROR,
          5000,
          200
        );
      }
    });
  };

  /**
   * call on submit button
   * @returns 
   */
  onSubmit = () => {
    const {
      tenantContactId,
      selectedPropertyId,
      contactName,
      email,
      officePhone,
      cellPhone,
      permissionRequestTypeIds,
      selectedTenantId,
      effectiveFromDate,
      effectiveToDate,
      isAdminContactType,
      tenantsFromTenantView,
      sendEmail,
      isReceiveCommunication,
      tenantEffectiveToDate
    } = this.state;

    let filteredTenantId = 0;
    if (tenantsFromTenantView && tenantsFromTenantView.length > 0) {
      filteredTenantId =
        tenantsFromTenantView.filter(
          tenant => tenant.PropertyId == selectedPropertyId
        )[0]?.TenantId || selectedTenantId;
    } else {
      filteredTenantId = selectedTenantId;
    }

    const tenantEffectiveFrom = effectiveFromDate
      ? new Date(effectiveFromDate).getMonth() +
        1 +
        "/" +
        new Date(effectiveFromDate).getDate() +
        "/" +
        new Date(effectiveFromDate).getFullYear()
      : effectiveFromDate;

    const tenantEffectiveTo = effectiveToDate
      ? new Date(effectiveToDate).getMonth() +
        1 +
        "/" +
        new Date(effectiveToDate).getDate() +
        "/" +
        new Date(effectiveToDate).getFullYear()
      : effectiveToDate;

    const contactBody = {
      tenantUserId: tenantContactId,
      tenantId: filteredTenantId,
      propertyId: selectedPropertyId,
      userName: contactName.trim(),
      officePhone: (officePhone || "").replaceAll("-", ""),
      cellPhone: (cellPhone || "").replaceAll("-", ""),
      email,
      permissionRequestTypeIds: permissionRequestTypeIds.toString(),
      effectiveDate: tenantEffectiveFrom,
      expireDate: tenantEffectiveTo ? tenantEffectiveTo : "",
      contactType: isAdminContactType ? "Admin" : "User",
      sendInvitationEmail: sendEmail,
      isReceiveCommunication: isReceiveCommunication
    };

    if (validateInput(contactBody, contactValidation)) {
      if (effectiveToDate) {
        const fromDate = moment(effectiveFromDate)["_d"];

        const toDate = moment(effectiveToDate)["_d"];
        const tenantEffectiveDate  = (tenantEffectiveToDate !== "" &&  tenantEffectiveToDate !== null) ? moment(tenantEffectiveToDate)["_d"] : "";
       

        if (toDate < fromDate) {
          ShowToast(
            <>
              <b>{"Invalid Data: "} </b>
              <br />{" "}
              {
                "Effective To Date can not be less that Effective From Date"
              }{" "}
            </>,
            toastType.ERROR,
            5000,
            200
          );
          return;
        } else if (tenantEffectiveDate !== "" && toDate > tenantEffectiveDate) {
          ShowToast(
            <>
              <b>{"Invalid Data: "} </b>
              <br />{" "}
              {
                "Effective To Date can not be greater than Tenant Effective To Date"
              }{" "}
            </>,
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      }

      if (tenantContactId) {
        this.updateTenantContact(contactBody);
      } else {
        this.addTenantContact(contactBody);
      }
    }
  };

  /**
   * call on add tenant contact 
   * @param {*} params 
   */
  addTenantContact = params => {
    apiPost({
      url: API_URL.tenantContact.AddTenantContact,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (!success) {
        ShowToast(response?.data?.Message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success) {
        ShowToast(
          "Tenant Contact added Successfully",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.onSave(true);
      } else {
        this.props.onSave(false);
      }
    });
  };

  /**
   * call on update tenant contact
   * @param {*} params 
   */
  updateTenantContact = params => {
    apiPut({
      url: API_URL.tenantContact.UpdateTenantContact,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (response?.data?.Success == 0) {
        ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
        return;
      } else if (success) {
        ShowToast(
          "Tenant Contact Updated Successfully",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.onSave(true);
      }
    });
  };

  /**
   * call on onchange of field
   * @param {*} e 
   */
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**
   * remove hypan when press the backspace
   * @param {*} newState 
   * @param {*} oldState 
   * @param {*} userInput 
   * @returns 
   */
  beforeMaskedValueChangeForCellPhone = (newState, oldState, userInput) => {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPosition = selection ? selection.start : null;
 
    // keep minus if entered by user
    if (value?.endsWith("-") && userInput !== "-" && !this.state["cellPhone"]?.endsWith("-")) {
      if (cursorPosition === value.length) {
        cursorPosition--;
        selection = { start: cursorPosition, end: cursorPosition };
      }
      value = value.slice(0, -1);
    }
 
    return {
      value,
      selection
    };
  }

  
  /**
   * remove hypan when press the backspace
   * @param {*} newState 
   * @param {*} oldState 
   * @param {*} userInput 
   * @returns 
   */
  beforeMaskedValueChangeForOfficePhone = (newState, oldState, userInput) => {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPosition = selection ? selection.start : null;
 
    // keep minus if entered by user
    if (value?.endsWith("-") && userInput !== "-" && !this.state["officePhone"]?.endsWith("-")) {
      if (cursorPosition === value.length) {
        cursorPosition--;
        selection = { start: cursorPosition, end: cursorPosition };
      }
      value = value.slice(0, -1);
    }
 
    return {
      value,
      selection
    };
  }
  
  /**
   * call on property select dropdown
   * @param {*} id 
   */
  onPropertySelect = id => {
    const { tenantsFromTenantView, tenantEffectiveToDate } = this.props;
    const tenantEffectiveDate =  tenantEffectiveToDate
    ? tenantEffectiveToDate
    : tenantsFromTenantView
    ? tenantsFromTenantView?.find(x=> x.PropertyId?.toString() === id?.toString())?.EffectiveTo
    : null;
    this.setState({ selectedPropertyId: id, tenantEffectiveToDate: tenantEffectiveDate, effectiveToDate:  tenantEffectiveDate});
  };

  /**
   * call on request change
   * @param {*} id 
   */
  onRequestChange = id => {
    const { permissionRequestTypeIds } = this.state;
    const { masterData } = this.props;
    const allRequestTypeMaster =
      (masterData &&
        masterData.requestTypeMaster.map(function(a) {
          return a.RequestTypeId;
        })) ||
      [];

    if (permissionRequestTypeIds.indexOf(id) !== -1) {
      remove(permissionRequestTypeIds, n => n == id);
      this.setState({
        permissionRequestTypeIds: permissionRequestTypeIds,
        selectAllRequestPermission:
          allRequestTypeMaster.length == permissionRequestTypeIds.length
      });
    } else {
      this.setState({
        permissionRequestTypeIds: [...permissionRequestTypeIds, id],
        selectAllRequestPermission:
          allRequestTypeMaster.length == permissionRequestTypeIds.length + 1
      });
    }
  };

  /**
   * set value on radio changes
   * @param {*} value 
   *   @param {*} name
   */
  handleSendEmailChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  /**
   * call on admin contact change
   * @param {*} isAdmin 
   */
  onAdminContactChange = isAdmin => {
    const { masterData } = this.props;
    const allRequestTypeMaster =
      (masterData &&
        masterData.requestTypeMaster.map(function(a) {
          return a.RequestTypeId;
        })) ||
      [];
    if (isAdmin) {
      this.setState({
        isAdminContactType: isAdmin,
        permissionRequestTypeIds: allRequestTypeMaster,
        selectAllRequestPermission: true
      });
    } else {
      this.setState({
        isAdminContactType: isAdmin,
        permissionRequestTypeIds: [],
        selectAllRequestPermission: false
      });
    }
  };

  /**
   * call on select all request permission changes 
   * @param {*} isAll 
   */
  onSelectAllRequestPermissionChange = isAll => {
    if (isAll) {
      const { masterData } = this.props;
      this.setState({
        selectAllRequestPermission: isAll,
        permissionRequestTypeIds:
          masterData &&
          masterData.requestTypeMaster.map(function(a) {
            return a.RequestTypeId;
          })
      });
    } else {
      this.setState({
        selectAllRequestPermission: isAll,
        permissionRequestTypeIds: []
      });
    }
  };

  /**
   * call on render tooltip
   * @param {*} txtToolTip 
   * @param {*} isRequired 
   * @returns 
   */
  renderToolTip = (txtToolTip, isRequired = false) => {
    const toolTip = this.state.getToolTip?.find(b => b.UiColumnName == txtToolTip)
      ?.Tooltip;
    return (
      <>
        {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
        {toolTip && (
          <Tooltip title={toolTip}>
            <IconButton size={"small"} className={"tooltip-iconSize"}>
              <InfoOutlined fontSize={"inherit"} />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };
  render() {
    const {
      permissionRequestTypeIds,
      dataCenterList,
      selectedPropertyId,
      contactSuggestions,
      contactName,
      contactFocus,
      email,
      tenantEffectiveToDate,
      sendEmail,
      isReceiveCommunication,
      getToolTip,
      tenantContactId,
      invitationSentDate,
      officePhone,
      effectiveToDate,
      createdOn,
      modifiedOn
    } = this.state;
    const { masterData } = this.props;
    const isTenant = IsTenant();
    const filteredDataCenter = isTenant
      ? dataCenterList
      : dataCenterList?.filter(d => d.propertyID == selectedPropertyId) || [];
    const contactFilter =
      contactName && contactName.length > 1 && contactFocus
        ? contactSuggestions.filter(
            x =>
              (x.title || "")
                .toLowerCase()
                .search(contactName.toLowerCase()) !== -1
          )
        : [];

    const loggedInEmail = GetUserConfiguration()?.email;
    const tenantCanEditSelfInfo = loggedInEmail == email;
    const isViewOnly = isTenant && !IsTenantAdmin();

    const createdDateTime = createdOn
          ? moment(createdOn).format("MM/DD/YYYY hh:mm A")
          : moment(new Date()).format("MM/DD/YYYY hh:mm A");

    const modifiedDateTime = modifiedOn
          ? moment(modifiedOn).format("MM/DD/YYYY hh:mm A")
          : null;
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={() => this.props.onClose(false)}
          PaperComponent={PaperComponent}
          fullWidth
          maxWidth={"md"}
          className={"addUpdateContact"}
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {this.props.tenantContactId > 0
                  ? "Edit Tenant Contact"
                  : "Add Tenant Contact"}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.props.onClose(false)}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent>
            <Box
              component={"form"}
              border={0}
              borderColor={"grey.500"}
              borderRadius={1}
              noValidate
              autoComplete={"off"}
              className={"tenantTable"}
            >
              
              <div className={"row"}>
                <div className={"col-xs-4 col-md-4 col-lg-4"}>
                  <FormLabel component={"legend"} className={"legend-text-label"} size={"small"} id={"createdOn"}>
                     {"Created On :"}{" "}
                      { createdDateTime ? (
                        createdDateTime
                      ) : null}
                  </FormLabel>
                </div>
                {
                  <div className={"col-xs-4 col-md-4 col-lg-4"}>
                    <FormLabel component={"legend"} className={"legend-text-label"} size={"small"} id={"modifiedOn"}>
                        {"Modified On :"}{" "}
                        { modifiedDateTime ? (
                          modifiedDateTime
                        ) : null}
                    </FormLabel>                   
                  </div>
                }
              </div>
              &nbsp; &nbsp;
              <div className={"row"}>
                <div className={"col-xs-6 col-lg-4"}>
                  <div className={"auto-populate-container"}>
                    <TextFieldWithToolTip
                      isRequired
                      labelHeading={"Contact Name"}
                      toolTip={
                        this.state.getToolTip?.find(
                          b => b.UiColumnName == "Contact Name"
                        )?.Tooltip
                      }
                      id={"contactName"}
                      txtName={"contactName"}
                      value={contactName || ""}
                      onChange={this.handleChange}
                      onFocus={() => this.setState({ contactFocus: true })}
                      onBlur={() => this.setState({ contactFocus: false })}
                      disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                      className={
                        isViewOnly && !tenantCanEditSelfInfo ? "disabled" : ""
                      }
                    />
                    <div className={"populate-list"}>
                      {contactFilter.map(ct => (
                        <div className={"list-item"}>{ct.title}</div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className={"col-xs-6 col-lg-4"} style={{ marginTop: "5px" }}>
                  <FormControl fullWidth>
                    <div className={"col-xs-12"}>
                      <lable
                        id={"dataCenter-list"}
                        className={isViewOnly ? "disabled" : ""}
                      >
                        {"Data Center "}{this.renderToolTip("Data Center", true)}{" "}
                      </lable>
                    </div>
                  </FormControl>
                  <FormControl fullWidth>
                    <div className={"col-xs-12"}>
                      <Select
                        fullWidth
                        labelId={"dataCenter-list"}
                        id={"dataCenter-list-select"}
                        label={"DataCenter"}
                        value={this.state.selectedPropertyId}
                        onChange={e => this.onPropertySelect(e.target.value)}
                        disabled={isViewOnly}
                        className={isViewOnly ? "disabled" : ""}
                      >
                        {(filteredDataCenter || []).map((item, index) => (
                          <MenuItem
                            key={"dcList" + index}
                            value={item.propertyID}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </FormControl>
                </div>

                <div className={"col-xs-12 col-lg-4"}>
                  <TextFieldWithToolTip
                    id={"email"}
                    txtName={"email"}
                    isRequired
                    labelHeading={"Email"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Email"
                      )?.Tooltip
                    }
                    value={email || ""}
                    onChange={this.handleChange}
                    disabled={isViewOnly}
                    className={isViewOnly ? "disabled" : ""}
                  />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-xs-6 col-lg-4"}>
                  <InputMask
                    mask={"999-999-9999"}
                    value={officePhone}
                    maskChar={null}
                    beforeMaskedValueChange={this.beforeMaskedValueChangeForOfficePhone}
                    onChange={this.handleChange}
                    disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                    className={
                      isViewOnly && !tenantCanEditSelfInfo ? "disabled" : ""
                    }
                  >
                    {() => (
                      <TextFieldWithToolTip
                        id={"officePhone"}
                        txtName={"officePhone"}
                        labelHeading={"Work Phone"}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == "Office Phone"
                          )?.Tooltip
                        }
                        disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                        className={
                          isViewOnly && !tenantCanEditSelfInfo ? "disabled" : ""
                        }
                      />
                    )}
                  </InputMask>
                </div>
                <div className={"col-xs-6 col-lg-4"}>
                  <InputMask
                    mask={"999-999-9999"}
                    value={this.state.cellPhone}
                    maskChar={null}
                    beforeMaskedValueChange={this.beforeMaskedValueChangeForCellPhone}
                    onChange={this.handleChange}
                    disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                    className={
                      isViewOnly && !tenantCanEditSelfInfo ? "disabled" : ""
                    }
                  >
                    {() => (
                      <TextFieldWithToolTip
                        id={"cellphone"}
                        txtName={"cellPhone"}
                        labelHeading={"Cell Phone"}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == "Cell Phone"
                          )?.Tooltip
                        }
                        disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                        className={
                          isViewOnly && !tenantCanEditSelfInfo ? "disabled" : ""
                        }
                      />
                    )}
                  </InputMask>
                </div>
                <div className={"col-xs-12 col-lg-4"}>
                  <KeyBoardDatePickers
                    id={"effectiveFrom"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Effective From"
                      )?.Tooltip
                    }
                    valueDate={this.state.effectiveFromDate}
                    label={"Effective From"}
                    format={"MM/DD/yyyy"}
                    required
                    handleChange={date =>
                      this.setState({ effectiveFromDate: date })}
                    disabled={isViewOnly}
                  />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 col-lg-4"}>
                  <KeyBoardDatePickers
                    id={"effectiveTo"}
                    valueDate={ effectiveToDate }
                    label={"Effective To"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Effective To"
                      )?.Tooltip
                    }
                    format={"MM/DD/yyyy"}
                    minDate={this.state.effectiveFromDate || "1/1/1700"}
                    maxDate={tenantEffectiveToDate}
                    handleChange={date =>
                      this.setState({ effectiveToDate: date })}
                    disabled={isViewOnly}
                  />
                </div>
                {(tenantContactId > 0) && (
                  <div className={"col-xs-12 col-lg-4"}>
                    <TextFieldWithToolTip
                      labelHeading={"Invitation Sent Date"}
                      toolTip={
                        this.state.getToolTip?.find(
                          b => b.UiColumnName == "Invitation Sent Date"
                        )?.Tooltip
                      }
                      id={"invitationSentDate"}
                      txtName={"invitationSentDate"}
                      value={invitationSentDate !== null ? moment(invitationSentDate).format(standardDateFormat) : ""}
                      disabled
                      className={"disabled"}
                    />
                  </div>

                )}
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 col-lg-4"}>
                  <LabelWithSwitch
                    key={"contactType"}
                    labelHeading={"Admin Contact"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Admin Contact button"
                      )?.Tooltip
                    }
                    selectedValue={this.state.isAdminContactType}
                    onChange={(k, v) => this.onAdminContactChange(v)}
                    inlineStyle={{ paddingLeft: "0.4em", paddingTop: "0.5em" }}
                    disabled={isViewOnly}
                  />
                </div>
                <div className={"col-xs-12 col-lg-4"}>
                  <LabelWithSwitch
                    key={"receiveCommunication"}
                    labelHeading={"Receive Communication"}
                    toolTip={
                      getToolTip?.find(
                        b => b.UiColumnName == "Receive Communication"
                      )?.Tooltip
                    }
                    selectedValue={isReceiveCommunication}
                    onChange={(k, v) => this.handleSendEmailChange(v, "isReceiveCommunication")}
                    inlineStyle={{ paddingLeft: "0.4em", paddingTop: "0.5em" }}
                    disabled={tenantCanEditSelfInfo ? false : isViewOnly}
                  />
                </div>

                {(!tenantContactId || tenantContactId == 0) && ( 
                  <div className={"col-xs-12 col-lg-4"}>
                    <LabelWithSwitch
                      key={"sendEmail"}
                      labelHeading={"Send Invitation Email"}
                      toolTip={
                        this.state.getToolTip?.find(
                          b => b.UiColumnName == "Send Invitation Email"
                        )?.Tooltip
                      }
                      selectedValue={sendEmail}
                      onChange={(k, v) => this.handleSendEmailChange(v, "sendEmail")}
                      inlineStyle={{
                        paddingLeft: "0.4em",
                        paddingTop: "0.5em"
                      }}
                    />
                  </div>
                )}               
               
              </div>
              <div style={{ marginLeft: "0.7rem", marginRight: "0.7rem" }}>
                <hr
                  style={{
                    color: "black",
                    backgroundColor: "black",
                    height: 2
                  }}
                />
              </div>
              <div className={"row"}>
                <div className={"col-xs-12"}>
                  <span
                    style={{
                      float: "left",
                      paddingTop: "0.8rem",
                      marginRight: "0.8rem",
                      marginLeft: "0.8rem"
                    }}
                  >
                    <b>{"Request Permissions"}</b>
                  </span>
                  <LabelWithSwitch
                    key={"selectAllRequestPermission"}
                    labelHeading={"Select All"}
                    selectedValue={
                      this.state.selectAllRequestPermission ||
                      (
                        masterData &&
                        masterData.requestTypeMaster.map(function(a) {
                          return a.RequestTypeId;
                        })
                      ).length == permissionRequestTypeIds.length
                    }
                    onChange={(k, v) =>
                      this.onSelectAllRequestPermissionChange(v)}
                    disabled={isViewOnly}
                  />
                </div>
              </div>
              <div className={"row"}>
                {masterData &&
                  masterData.requestTypeMaster.map(rp => {
                    return (
                      <div className={"col-xs-6 col-lg-4"}>
                        <LabelWithSwitch
                          key={rp.RequestType}
                          labelHeading={rp.RequestType}
                          selectedValue={
                            permissionRequestTypeIds.indexOf(
                              rp.RequestTypeId
                            ) !== -1
                              ? true
                              : false
                          }
                          onChange={() =>
                            this.onRequestChange(rp.RequestTypeId)}
                          tooltipTitle={rp.Description}
                          disabled={isViewOnly}
                        />
                      </div>
                    );
                  })}
              </div>
            </Box>
          </DialogContent>
          <DialogActions style={{ paddingRight: "24px" }}>
            <Button
              style={{ marginRight: "8px" }}
              autoFocus
              color={"primary"}
              onClick={() => this.props.onClose(false)}
            >
              {"Close\r"}
            </Button>
            {(!isViewOnly || tenantCanEditSelfInfo) && (
              <Button
                style={{ marginRight: "8px" }}
                autoFocus
                color={"primary"}
                onClick={this.onSubmit}
                disabled={tenantCanEditSelfInfo ? false : isViewOnly}
              >
                {"Save\r"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddUpdateTenantContact;
